import { createWebHistory } from 'vue-router'

const h5Router = {
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/H5/pages/Home/index.vue')
    },
    {
      path: '/content/:contentId',
      name: 'contentDetail',
      component: () => import('@/views/H5/pages/ContentDetail/index.vue')
    },
    {
      path: '/:catchAll(.*)',
      name: '404',
      redirect: '/'
    }
  ]
}

export default h5Router
